import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var CertificateIcon = function CertificateIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "CertificateIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 2.463c-1.99 0-3.618 1.625-3.618 3.65S6.01 9.763 8 9.763s3.618-1.625 3.618-3.65S9.988 2.463 8 2.463m-5.092 3.65C2.908 3.298 5.178 1 8 1s5.092 2.298 5.092 5.113c0 .983-.277 1.904-.758 2.685l1.58 3.18a.83.83 0 0 1-.748 1.195h-1.804l-.68 1.365a.836.836 0 0 1-1.494 0L8 12.148l-1.188 2.39a.836.836 0 0 1-1.495 0l-.679-1.365H2.834a.83.83 0 0 1-.748-1.196l1.58-3.179a5.1 5.1 0 0 1-.758-2.685m1.798 3.9-.844 1.697h1.175c.32 0 .608.183.747.462l.28.564.813-1.635a5.06 5.06 0 0 1-2.171-1.089M9.123 11.1a5.06 5.06 0 0 0 2.17-1.089l.845 1.698h-1.175a.83.83 0 0 0-.747.462l-.28.564z",
      clipRule: "evenodd"
    })
  }));
};

export { CertificateIcon };
